module.exports = __webpack_public_path__ + "static/img/06.9c85c9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/artical/horse/06.png
// module id = pyls
// module chunks = 1